module.exports = __webpack_public_path__ + "static/media/icon-recycle.82b9da07.svg";